// extracted by mini-css-extract-plugin
export var menuIconBtn = "buttons-module--menuIconBtn--1x9nf";
export var menuIcon = "buttons-module--menuIcon--3GfQg";
export var transparentBtn = "buttons-module--transparentBtn--1bvSO";
export var primary = "buttons-module--primary--3hMpO";
export var secondary = "buttons-module--secondary--2uuHJ";